import Tasks from 'APP/Tasks';
import {
  ISubscribeToCalendarPushParams,
  CalendarModelErrorCode,
} from 'APP/model/calendar/calendar.types';
import { calendarModel } from 'APP/model/model';

export async function subscribeToCalendarPush(
  params: ISubscribeToCalendarPushParams
): Promise<boolean> {
  try {
    const response = await calendarModel.subscribeToCalendarPush(params);

    return response;
  } catch (error) {
    if (error.message === CalendarModelErrorCode.Unauthorized) {
      Tasks.calendar.handleCalendarUnauthorized();
    }
    return false;
  }
}
